// removed by extract-text-webpack-plugin
module.exports = {"markdownDetailRoot":"markdownDetailRoot--ea4aa","markdownDetail":"markdownDetail--d6406"};